module.exports = __webpack_public_path__ + "img/1f3d3.448f3e1.svg";